import returnTypes from './return-types';

export default () => ({
  returnTypes: returnTypes(),
});
